import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../core/config/core.httpclient-utils';

import * as _ from 'lodash';
import { UserService } from '../../core/services/core.user.service';

@Component({
    selector: 'gf-members-selector',
    template: require('./members.selector.component.html')
})
export class MembersSelectorComponent implements OnInit {
    @Input() project: any = {};
    @Input() callback;
    @Input() initialSelectedMember: any = null; // Initial selected member for single selection
    @Input() config: {
        singleSelection?: boolean;
        showSelectedMembers?: boolean;
        allowNobody?: boolean;
    } = {
        singleSelection: false,
        showSelectedMembers: true,
        allowNobody: true
    };

    debouncedGetFilteredMembers: any = null;
    membersList = [];
    selectedMembersList = []; // List of selected members to show at top
    nonSelectedMembersList = []; // List of non-selected members
    selectedMembers = [];
    selectedMembersDisplay = [];
    currentUser: any = {};
    selectedTitle = '';
    membersCount = 0;
    maxAvatars = 3;
    membersFilter = '';
    initialMembersList: any = false;

    constructor(
        private httpClient: HttpClient,
        private userService: UserService
    ) {
    }

    ngOnInit() {
        this.currentUser = this.userService.getUser();
        this.fetchMembersList();
        this.debouncedGetFilteredMembers = _.debounce(this.fetchMembersList, 250, { 'maxWait': 1000 });
        
        // Initialize with initial selected member if provided
        if (this.config.singleSelection && this.initialSelectedMember) {
            this.selectedMembers = [this.initialSelectedMember];
        }
    }

    setMe() {
        if (this.userService.hasUser()) {
            this.selectedMembers = [ this.currentUser ];
            this.updateSelectionTotals();
            this.toggleMember(this.currentUser);
        }
    }

    setNobody() {
        this.selectedMembers = [ this.userService.getNobody() ];
        this.updateSelectionTotals();
    }

    /**
     * Sets the given member as an
     * assignee to the TI
     * @param {object} member 
     */
    setMember(ev: any, member) {
        ev.preventDefault();
        ev.stopPropagation();

        this.toggleMember(member);
    }

    fetchMembersList(search: string = '') {

        const unixName = this.project.unixName;
        var params: any = {
            groups: 'false',
            group: 'true',
            page_size: 100
        };

        if (search?.length > 0 && search != '') {
            params['search'] = search;
        }

        const url = `/api/project/${unixName}/members`;

        doGetPromise(this.httpClient, url, params)
            .then((response) => {
                this.setMembersList(_.get(response, 'items', []));
            })
            .catch((err) => console.log(err));
    }

    getSelectedMembersTitle() {
        var slice = this.maxAvatars || 0;
        return this.selectedMembers
            .slice(slice)
            .filter((item) => item !== this.userService.isNobody)
            .map(this.userService.fullName)
            .join(', ');
    };

    toggleMember(member: any) {
        if (this.config.singleSelection) {
            // For single selection, replace the current selection
            this.selectedMembers = [member];
            if (typeof this.callback === 'function') {
                this.callback(this.selectedMembers);
            }
        } else {
            // Multi-selection logic
            if (!_.find(this.selectedMembers, { id: member.id })) {
                this.selectedMembers.push(member);
                if (typeof this.callback === 'function') {
                    this.callback(this.selectedMembers);
                }
            } else {
                _.remove(this.selectedMembers, { id: member.id });
            }
        }

        this.updateSelectionTotals();
    }

    updateSelectionTotals() {
        this.membersCount = this.selectedMembers.length;
        this.selectedTitle = this.getSelectedMembersTitle();
        
        // Mark all members with selected status
        this.membersList = this.membersList.map((m) => {
            m.selected = _.find(this.selectedMembers, { id: m.id }) ? true : false;
            return m;
        });
        
        // Separate selected and non-selected members
        this.selectedMembersList = this.membersList.filter((m) => m.selected);
        this.nonSelectedMembersList = this.membersList.filter((m) => !m.selected);
        
        this.selectedMembers = _.sortBy(this.selectedMembers, ['firstname', 'lastname']);
        this.selectedMembersDisplay = this.selectedMembers.slice(0, this.maxAvatars);
    }

    /**
     * Updates the current members list to be displayed in 
     * the selector with:
     *   - the currently and previously assigned members
     *   - the remaining members from the current members page
     * 
     * @param {Array} members 
     */
    setMembersList(members) {
        // Sort by / display by firstname lastname
        this.membersList = _.sortBy(
            // Remove Nobody user from list
            _.filter(members, function(u: any) { return u.id > 100; }), 
            ['firstname', 'lastname']
        );
        this.updateSelectionTotals();
    }

    trackByUnixName(index: number, member: any): any {
        return member.unixName;
    }
}